import { defineStore } from 'pinia'

export const useConfigChangeRequestsStore = defineStore('configChangeRequests', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getConfigChangeRequests: (state) => state.data?.data,
  },
  actions: {
    async indexConfigChangeRequests(params = {}) {
      try {
        const response = await axios.get('config-change-requests', {params});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    /**
     * Fetch every config change request for a single device, regardless of status.
     * Returns the response rather than storing it, so it does not clobber the
     * paginated list held for the admin index page.
     */
    async indexDeviceConfigChangeRequests(deviceId, params = {}) {
      try {
        const response = await axios.get('config-change-requests', {
          params: {
            ...params,
            filter: {...params.filter, device_id: deviceId},
          },
        });
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
